import React, { FC } from "react"
import { rhythm } from "../../utils/typography"
import Image from "gatsby-image"

interface Props {
  author: string
  twitter: string
  fixed: object
}

const Hero: FC<Props> = ({ author = "", twitter = "", fixed = {} }) => {
  return (
    <div
      style={{
        display: `flex`,
        marginBottom: rhythm(2.5),
      }}
    >
      <Image
        fixed={fixed}
        alt={author}
        style={{
          marginRight: rhythm(1 / 2),
          marginBottom: 0,
          minWidth: 50,
          borderRadius: `100%`,
        }}
        imgStyle={{
          borderRadius: `50%`,
        }}
      />
      <p>
        <strong>(BLOG IS UNDER CONSTRUCTION 🚧)</strong> Written by{" "}
        <strong>{author}</strong> who lives and works in Boston, MA.
        {` `}
        <a href={`https://twitter.com/${twitter}`}>
          You should follow him on Twitter
        </a>
      </p>
    </div>
  )
}

export default Hero
